// extracted by mini-css-extract-plugin
export default {"inputAreaWrapper":"SaFGB1H7RuQPTgCvp_j4","disabled":"bTtkWjOwGGwcakdvgiQu","inputArea":"tM613k4_A3g1DdXjqUUg","ninja":"ST0vlQHYJU2_i6p8gQM0","showBackground":"I4N5ms60_gtQjUP66Gwo"};